<template>
  <div>
    <vs-button color="#15c1c3">Column Setting</vs-button>
    <vs-button class="ml-3" color="#15c1c3">Filter By</vs-button>
  </div>
</template>
<script>
import themeConfig from "@/../themeConfig.js";
export default {
  data() {
    return {
      bermuda: themeConfig.theme.bermuda
    };
  }
};
</script>
<style lang="scss"></style>
